export default {
  sales: {
    EventName: 'Event Name',
    PromotionTime: 'Promotion Time',
    ProductName: 'Product Name',
    Type: 'Type',
    StartTime: 'StartTime',
    PromotionType: 'Promotion Type',
    EndTime: 'EndTime',
    PromotionArea: 'Promotion Area',
    Status: 'Status',
    PromotionObject: 'Promotion Object',
    CreateTime: 'CreateTime',
    ModifyTime: 'ModifyTime',
    NewGift: 'New Gift',
    NewDecline: 'New Decline',
    NewDiscount: 'New Discount',
    ProductGift: 'Product Gift',
    ProductDecline: 'Product Decline',
    ProductDiscount: 'Product Discount',
    QuantityGift: 'Quantity Gift',
    QuantityDecline: 'Quantity Decline',
    QuantityDiscount: 'Quantity Discount',
    OrderGift: 'Order Gift',
    OrderDecline: 'Order Decline',
    OrderDiscount: 'Order Discount',

    ProductCode: 'Product Code',
    PromotionRules: 'Promotion Rules',
    PromotionalGoods: 'Promotional Goods',
    ActivityTime: 'Activity Time',
    Quantity: 'Quantity',
    Gift: 'Gift',
    NoData: 'No Data',
    OrderPrice: 'Order Price',
    OrderPriceDecline: 'Order price decline',
    CustomerType: 'Customer Type',
    Dealer: 'Dealer',
    Area: 'Area',
    SelectAll: 'Select All',
    DiscountOnTheOriginalOrderPrice: 'Discount On The Original Order Price',
    ProductSelect: 'Product Select',
    AreaSelect: 'Area Select',
    DealerSelect: 'Dealer Select',
    CustomerTypeSelect: 'Select At Least One Customer Type',
    DealerCode: 'Dealer Code',
    DealerName: 'Dealer Name',
    PleaseChooseDate: 'Please Choose Date',
    CanNotBeEmpty: 'Can Not Be Empty',
    NoSpaces: 'No Spaces'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/mcc/sales/sales.js